// extracted by mini-css-extract-plugin
module.exports = {"AdminReports":"styles_AdminReports__38rjY","AdminReportsBody":"styles_AdminReportsBody__2E1ZD","BackHome":"styles_BackHome__2Hc0k"};